import {Injectable} from "@angular/core";

import {User} from "../_models/index";
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UserService {
	constructor(private http: HttpClient) {
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/authentication/_services/user.service.ts